import type { SVGProps } from 'react';

const Icon = ({ children, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    {children}
  </svg>
);

export const UploadIcon = () => (
  <Icon>
    <path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5" />
    <path d="M5 14v5h14v-5" />
  </Icon>
);

export const CloseIcon = () => (
  <Icon>
    <path d="m6 6 12 12M18 6 6 18" />
  </Icon>
);

export const ArrowIcon = ({ direction }: { direction: 'left' | 'right' }) => (
  <Icon style={direction === 'left' ? { transform: 'rotate(180deg)' } : undefined}>
    <path d="M5 12h14m-5-5 5 5-5 5" />
  </Icon>
);

export const DownloadIcon = () => (
  <Icon>
    <path d="M12 4v11m0 0 4-4m-4 4-4-4M5 19h14" />
  </Icon>
);

export const TrashIcon = () => (
  <Icon>
    <path d="M4 7h16M9 7V4h6v3m3 0-1 13H7L6 7m4 4v5m4-5v5" />
  </Icon>
);

export const PlayIcon = () => (
  <Icon fill="currentColor" stroke="none">
    <path d="M8.75 6.5 17 12l-8.25 5.5Z" />
  </Icon>
);
